import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import Button from '../../buttons/Button/Button';
import './ServiceCard.css';

const ServiceCard = ({ title, desc, image, link, serviceLink, leftDesc }) => {
  return (
    <div
      className='service-card-container'
      style={{ backgroundImage: `url("${image}")` }}
    >
      <div id='service-desc-container'>
        <h1 id='service-title'>{title}</h1>
        {leftDesc && (
          <p id='service-desc__left'>
            <LinkifiedText>{leftDesc}</LinkifiedText>
          </p>
        )}
        {link && <Button href={link}>Book Appointment</Button>}
      </div>
      <div id='service-title-container'>
        <h1 id='service-title'>{title}</h1>
        <span id='service-learn-more'>Learn More</span>
      </div>
      {serviceLink && (
        <div className='service__btn'>
          <Button href={serviceLink}>Book Appointment</Button>
        </div>
      )}
    </div>
  );
};

export default ServiceCard;
